import merge from 'immutability-helper';
import { reportFunctionError } from 'src/utilities/sentry';
import { ActionType, defaultAction } from '../types';
import { ACTION_TYPES } from '../types/bcaUniqueCodeTopUpTypes';

type ChargeDestinationAccountData = {
  bankCode: string;
  accountNumber: string;
  accountName: string;
};

export type BcaUniqueCodeTopUpState = {
  id: string;
  amount: number;
  uniqueCode: number;
  uniqueAmount: number;
  chargeDestinationAccount: ChargeDestinationAccountData;
  expiredTime: number;
  hasAnyTransaction: boolean;
  status: string;
  isLoading: boolean;
};

const initialState: BcaUniqueCodeTopUpState = {
  id: '',
  amount: 0,
  uniqueCode: 0,
  uniqueAmount: 0,
  chargeDestinationAccount: {
    bankCode: '',
    accountNumber: '',
    accountName: '',
  },
  expiredTime: 0,
  hasAnyTransaction: false,
  status: '',

  isLoading: false,
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;

  switch (type) {
    case ACTION_TYPES.CREATE_BCA_UNIQUE_CODE_TOPUP_REQUEST:
      return merge(state, {
        isLoading: {
          $set: true,
        },
      });
    case ACTION_TYPES.CREATE_BCA_UNIQUE_CODE_TOPUP_SUCCESS:
      return merge(state, {
        $set: {
          id: payload.data.id,
          amount: payload.data.amount,
          uniqueCode: payload.data.unique_code,
          uniqueAmount: payload.data.unique_amount,
          chargeDestinationAccount: {
            bankCode: payload.data.charge_destination_account?.bankCode ?? '',
            accountNumber:
              payload.data.charge_destination_account?.accountNumber ?? '',
            accountName:
              payload.data.charge_destination_account?.accountName ?? '',
          },
          expiredTime: payload.data.expired_time,
          hasAnyTransaction: payload.data.has_any_transaction,
          status: payload.data.status,
          isLoading: false,
        },
      });
    case ACTION_TYPES.CREATE_BCA_UNIQUE_CODE_TOPUP_FAILED:
      reportFunctionError({
        domain: 'dashboard',
        message: 'Failed to request create BCA Unique Code Top Up',
        name: 'postCreateBcaUniqueCodeRequest',
        exception: payload,
        parentName: 'InputAmountForm',
      });
      return merge(state, {
        isLoading: {
          $set: false,
        },
      });
    case ACTION_TYPES.CANCEL_BCA_UNIQUE_CODE_TOPUP_REQUEST:
      return merge(state, {
        isLoading: {
          $set: true,
        },
      });
    case ACTION_TYPES.CANCEL_BCA_UNIQUE_CODE_TOPUP_SUCCESS:
      return merge(state, {
        $set: {
          id: payload.data.id,
          amount: 0,
          uniqueCode: 0,
          uniqueAmount: 0,
          chargeDestinationAccount: {
            bankCode: '',
            accountName: '',
            accountNumber: '',
          },
          expiredTime: 0,
          hasAnyTransaction: false,
          status: '',
          isLoading: false,
        },
      });
    case ACTION_TYPES.CANCEL_BCA_UNIQUE_CODE_TOPUP_FAILED:
      reportFunctionError({
        domain: 'dashboard',
        message: 'Failed to request cancel BCA Unique Code Top Up',
        name: 'postCancelBcaUniqueCodeRequest',
        exception: payload,
        parentName: 'HowToTopUpForm',
      });
      return merge(state, {
        isLoading: {
          $set: false,
        },
      });
    case ACTION_TYPES.CHECK_BCA_UNIQUE_CODE_TOPUP_REQUEST:
      return merge(state, {
        isLoading: {
          $set: true,
        },
      });
    case ACTION_TYPES.CHECK_BCA_UNIQUE_CODE_TOPUP_SUCCESS:
      return merge(state, {
        $set: {
          id: payload.data.id,
          amount: payload.data.amount,
          uniqueCode: payload.data.unique_code,
          uniqueAmount: payload.data.unique_amount,
          chargeDestinationAccount: {
            bankCode: payload.data.charge_destination_account?.bankCode ?? '',
            accountNumber:
              payload.data.charge_destination_account?.accountNumber ?? '',
            accountName:
              payload.data.charge_destination_account?.accountName ?? '',
          },
          expiredTime: payload.data.expired_time,
          hasAnyTransaction: payload.data.has_any_transaction,
          status: payload.data.status,
          isLoading: false,
        },
      });
    case ACTION_TYPES.CHECK_BCA_UNIQUE_CODE_TOPUP_FAILED:
      reportFunctionError({
        domain: 'dashboard',
        message: 'Failed to request check status of BCA Unique Code Top Up',
        name: 'getCheckBcaUniqueCodeRequest',
        exception: payload,
        parentName: 'InputAmountForm',
      });
      return merge(state, {
        isLoading: {
          $set: false,
        },
      });
    default:
      return state;
  }
};
